export const HEADER_MENU = [
    {
        id: 'menu-item-780',
        title: 'Главная',
        link: '/',
    },
    {
        id: 'menu-item-784',
        title: 'Все герои Дота 2',
        link: '/all-heroes/',
    },
    {
        id: 'menu-item-781',
        title: 'Как делать ставки',
        link: '/kak-delat-stavki/',
    },
    /*{
        id: 'menu-item-786',
        title: 'Ставки на Доту 2',
        link: '/stavki-na-dota-2-v-ggbet/',
    },
    {
        id: 'menu-item-785',
        title: 'Приветственный бонус',
        link: '/betting-bonus-conditions/',
    },*/
];